import { defineMessages } from "react-intl";
const messages = defineMessages({
    appSidebarAdminDashboard: {
        id: "aiDiscoverability.appSidebar.adminDashboard",
        defaultMessage: "Admin Dashboard",
    },
    appSidebarHome: {
        id: "aiDiscoverability.appSidebar.home",
        defaultMessage: "Portfolio Overview",
    },
    appSidebarOrganizationFallback: {
        id: "aiDiscoverability.appSidebar.organizationFallback",
        defaultMessage: "Your organization",
    },
    appSidebarPlayDemo: {
        id: "aiDiscoverability.appSidebar.playDemo",
        defaultMessage: "Play Demo",
    },
    appSidebarPlansBilling: {
        id: "aiDiscoverability.appSidebar.plansBilling",
        defaultMessage: "Billing & Pricing",
    },
    appSidebarAccountSettings: {
        id: "aiDiscoverability.appSidebar.accountSettings",
        defaultMessage: "Account Settings",
    },
    appSidebarLogout: {
        id: "aiDiscoverability.appSidebar.logout",
        defaultMessage: "Log Out",
    },
    communityCount: {
        id: "aiDiscoverability.appSidebar.communityCount",
        defaultMessage: "{count, plural, one {# Community} other {# Communities}}",
    },
    communitySearchPlaceholder: {
        id: "aiDiscoverability.appSidebar.communitySearchPlaceholder",
        defaultMessage: "Search",
    },
    communityListEmpty: {
        id: "aiDiscoverability.appSidebar.communityListEmpty",
        defaultMessage: "No communities yet",
    },
    communityNoMatches: {
        id: "aiDiscoverability.appSidebar.communityNoMatches",
        defaultMessage: "No communities match your search",
    },
    communityListError: {
        id: "aiDiscoverability.appSidebar.communityListError",
        defaultMessage: "Couldn't load your communities",
    },
    communityReport: {
        id: "aiDiscoverability.appSidebar.communityReport",
        defaultMessage: "Report",
    },
    communityTopicsAndSources: {
        id: "aiDiscoverability.appSidebar.communityTopicsAndSources",
        defaultMessage: "Topics & Sources",
    },
    communityNoReports: {
        id: "aiDiscoverability.appSidebar.communityNoReports",
        defaultMessage: "No report yet",
    },
});
export default messages;
